import { render, staticRenderFns } from "./LaboralRequestsAdminPage.vue?vue&type=template&id=d60b5778&"
import script from "./LaboralRequestsAdminPage.vue?vue&type=script&lang=js&"
export * from "./LaboralRequestsAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports